import { AppNS } from 'app';
import { getLoginAsAccessToken } from 'app/services/jwtService';
import { logoutUser } from 'app/store/auth/thunks/logout';
import { RootState } from 'app/store/rootReducer';
import LogoutIcon from 'app/ui_v2/icons/LogoutIcon';
import { useDispatch, useSelector } from 'react-redux';

import { Box, CircularProgress } from '@mui/material';

import NavigationElement from './NavigationElement';

export interface LogoutButtonProps {
  sidebarState?: boolean;
}

export default function LogoutButton(props: LogoutButtonProps) {
  const { sidebarState } = props;
  const dispatch = useDispatch();
  const { user, isLoggingOut } = useSelector((state: RootState) => state.auth);

  if (!user) {
    return null;
  }

  const loginAsToken = getLoginAsAccessToken();

  const item: AppNS.NavigationElement = {
    name: 'Logout',
    path: '/logout',
    icon: <LogoutIcon />,
    tooltip: loginAsToken ? 'Logout and back to Admin Panel' : 'Logout',
    disabled: isLoggingOut,
    handleClick: () => {
      dispatch(logoutUser());
    },
    id: 'logout',
    url: '',
  };

  return (
    <>
      {isLoggingOut && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '48px',
          }}
        >
          <CircularProgress color="secondary" size={20} />
        </Box>
      )}
      {!isLoggingOut && (
        <NavigationElement element={item} sidebarState={sidebarState} />
      )}
    </>
  );
}
